import { ZomentumRoutes } from "@/Contracts";
import { AllRolePermissions } from "@/Contracts/Users";
import { EIcons } from "@atoms/ZIcon/interface";
import { useFeatureFlag } from "@/Hooks/useFeature";

/* 
	{
		...
		permission: (AllRolePermission | null)
		Item is shown if the mentioned permission is enabled. By default null for items which do not require a permission. 
	}
*/

export default () => {
	const isMarketplacePipelineSyncingEnabled = useFeatureFlag(
		"marketplace_pipeline_syncing"
	);
	const showPartnerAlignFeaturesFlag = useFeatureFlag(
		"show_partner_align_features"
	);
	const isMcpPermissionsEnabled = useFeatureFlag("mcp_permissions");
	const settingsMenuItems = [
		{
			route: ZomentumRoutes.Preferences,
			icon: EIcons.SLIDERVERTICAL,
			title: "My Preferences",
			permission: null
		},
		{
			route: ZomentumRoutes.Notifications,
			icon: EIcons.NOTIFICATION,
			title: "Notifications",
			permission: null
		},
		{
			route: ZomentumRoutes.EmailTemplateSettings,
			icon: EIcons.EMAILTEMPLATE,
			title: "Email Templates",
			permission: AllRolePermissions.EMAIL_TEMPLATE_READ
		},
		{
			title: "Settings",
			disabled: true,
			permission: null
		},
		{
			route: ZomentumRoutes.AccountSettings,
			icon: EIcons.USERCIRCLE,
			title: "Account",
			permission: AllRolePermissions.ACCOUNT_READ
		},
		{
			route: ZomentumRoutes.EmailSettings,
			icon: EIcons.MAIL,
			title: "Email Settings",
			permission: AllRolePermissions.EMAIL_UPDATE
		},
		{
			route: ZomentumRoutes.UserSettings,
			icon: EIcons.USERSGROUP,
			title: "Users",
			permission: AllRolePermissions.USER_READ
		},
		{
			route: ZomentumRoutes.Suppliers,
			icon: EIcons.SUPPLIER,
			title: "Suppliers",
			permission: AllRolePermissions.SUPPLIER_READ
		},
		{
			route: ZomentumRoutes.PipelineSettings,
			icon: EIcons.PIPELINES,
			title: "Pipelines",
			permission: AllRolePermissions.PIPELINE_VIEW
		},
		{
			route: ZomentumRoutes.CustomFieldsSettings,
			icon: EIcons.CUSTOMEFIELDS,
			title: "Custom Fields",
			permission: AllRolePermissions.CUSTOM_FIELD_VIEW
		},
		{
			route: ZomentumRoutes.IntegrationSettings,
			icon: EIcons.INTEGRATIONS,
			title: "Integrations",
			permission: AllRolePermissions.COMPANY_CONNECT
		},
		{
			route: ZomentumRoutes.TaxRegionSettings,
			icon: EIcons.TAXSETUP,
			title: "Tax Setup",
			permission: AllRolePermissions.TAX_SETUP_READ
		}
	];
	if (!isMarketplacePipelineSyncingEnabled && showPartnerAlignFeaturesFlag) {
		settingsMenuItems.push({
			route: ZomentumRoutes.MarketplaceSettingsPage,
			icon: EIcons.MARKETPLACE,
			title: "Align Settings",
			permission: AllRolePermissions.ACCOUNT_READ
		});
	}
	if (isMcpPermissionsEnabled) {
		settingsMenuItems.push({
			route: ZomentumRoutes.McpPermissions,
			icon: EIcons.AUDITLOGS,
			title: "MCP Permissions",
			permission: AllRolePermissions.MCP_AUDIT_LOG_READ
		});
	}
	return settingsMenuItems;
};
